import { isApiError } from '@/services/api';
import type { InvoiceRejectionReason } from '../types/agreements.types';

function isValidReason(value: unknown): value is InvoiceRejectionReason {
    if (typeof value !== 'object' || value === null) return false;
    const candidate = value as Record<string, unknown>;
    const lineOk =
        candidate.line === null || (typeof candidate.line === 'number' && Number.isInteger(candidate.line) && candidate.line >= 0);
    return lineOk && typeof candidate.code === 'string' && candidate.code.length > 0;
}

export const BALANCE_REJECTION_CODES = ['selection_exceeds_balance', 'selection_within_balance', 'pot_empty'];

export const isBalanceRejection = (reasons: InvoiceRejectionReason[]): boolean =>
    reasons.some((reason) => reason.line === null && BALANCE_REJECTION_CODES.includes(reason.code));

/** The `reasons` extra on the invoice_rejected 422; [] for any other error. */
export function readInvoiceRejection(error: unknown): InvoiceRejectionReason[] {
    if (!isApiError(error) || error.status !== 422 || error.code !== 'invoice_rejected') {
        return [];
    }
    const reasons = (error.data as Record<string, unknown> | undefined)?.reasons;
    return Array.isArray(reasons) ? reasons.filter(isValidReason) : [];
}

export const FUNDING_APPROVAL_REJECTION_CODES = ['funding_approval_invalid', 'funding_approval_superseded'];

export const isFundingApprovalRejection = (reasons: InvoiceRejectionReason[]): boolean =>
    reasons.some((reason) => reason.line === null && FUNDING_APPROVAL_REJECTION_CODES.includes(reason.code));
